import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist';
import { animatedNatureBg } from '../components/start/custom/theme/const';
import { BGSize } from '../util';

const { persistAtom } = recoilPersist({
  key: 'recoil-persist', // configuration stay the same too
  storage: localStorage,
});

export const darkModeState = atom<boolean>({
  key: 'darkMode',
  default: true,
  effects_UNSTABLE: [persistAtom],
});

export const showState = atom<boolean>({
  key: 'show',
  default: false,
  effects_UNSTABLE: [persistAtom],
});

export const expandState = atom<boolean>({
  key: 'expandMode',
  default: false,
  effects_UNSTABLE: [persistAtom],
});

export const enterState = atom<boolean>({
  key: 'enter',
  default: false,
  effects_UNSTABLE: [persistAtom],
});

export const activeTabState = atom<string>({
  key: 'activeTab',
  default: 'home',
  effects_UNSTABLE: [persistAtom],
});

export const backgroundThemeState = atom<string>({
  key: 'backgroundTheme',
  default: animatedNatureBg,
  effects_UNSTABLE: [persistAtom],
});

export const backgroundState = atom<string>({
  key: 'background',
  default: '--main-view-bg',
  effects_UNSTABLE: [persistAtom],
});

export const backgroundSizeState = atom<BGSize>({
  key: 'backgroundSize',
  default: BGSize.Contain,
  effects_UNSTABLE: [persistAtom],
});

export const contactButtonHoverState = atom<string>({
  key: 'contactButton',
  default: '#2a341895',
  effects_UNSTABLE: [persistAtom],
});

export const fontFamilyState = atom<string>({
  key: 'fontFamily',
  default: '--firesans',
  effects_UNSTABLE: [persistAtom],
});

export const parentIdState = atom<string>({
  key: 'parentId',
  default: '',
  effects_UNSTABLE: [persistAtom],
});

export const navItemIdsState = atom<string[]>({
  key: 'navItemIdsState',
  default: ['navItem', 'navItem2', 'navItem3', 'navItem4'],
  effects_UNSTABLE: [persistAtom],
});

export const navItemHoverState = atom<string[]>({
  key: 'navItemHover',
  default: [
    '#1e6174',
    'rgba(206, 206, 206, 0.87)',
    'rgba(45, 221, 1, 0.87)',
    'rgb(209, 111, 55, 0.87)',
  ],
  effects_UNSTABLE: [persistAtom],
});

export const activeNavLinkIndexState = atom<number>({
  key: 'activeNavLinkIndex',
  default: 0,
  effects_UNSTABLE: [persistAtom],
});
